import { Component, getAssetPath, h, Host } from '@stencil/core';

import wcShared from '@web-components/shared';

@Component({
  tag: 'module-loader-component',
  styleUrl: 'main-loader.scss',
  shadow: true,
})
export class Loader {
  componentDidLoad() {
    wcShared.displayComponent('loader');
  }

  render() {
    return (
      <Host>
        <div class="module-loader">
          <img
            class="module-loader__img module-loader__img--1x"
            src={getAssetPath('./../assets/images/manager1x-' + wcShared?.store?.theme + '.gif')}
            alt={wcShared.translate('Loading')}
          />
          <img
            class="module-loader__img module-loader__img--2x"
            src={getAssetPath('./../assets/images/manager2x-' + wcShared?.store?.theme + '.gif')}
            alt={wcShared.translate('Loading')}
          />
        </div>
      </Host>
    );
  }
}
